// import Axios from "axios";

const axios = require('axios')

export default axios;